import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const ResourceCornSchema = z.object({
    /**
     * Resource Corn that tag is attached to
     * @example `corn:claims:claim:1234`
     */
    resourceCorn: CornSchema,
});
export const EmptyValueSchema = z.literal('EMPTY_VALUE');
export const TagSchema = z
    .object({
    /**
     * Label of tag
     * @example `LossType`
     */
    key: z.string(),
    /**
     * Value of tag
     * @example `Fire`
     */
    value: EmptyValueSchema.or(z.string()),
    /**
     * Color of tag
     * @example `#000000`
     */
    color: z.string().length(7).regex(/^#/).optional(),
})
    .merge(ResourceCornSchema);
export const TagKeysSchema = z.object({
    /**
     * Tagged resource corn
     * @example `RESOURCE#corn:claims:claim:abc123`
     */
    PK: z.string(),
    /**
     * Label of tag
     * @example `LossType`
     */
    SK: z.string(),
    /**
     * `SK` from primary index
     * @example `LossType`
     */
    'GSI-PK-1': z.string(),
    /**
     * `value` from primary index
     * @example `Fire`
     */
    'GSI-SK-1': z.string(),
    /**
     * If PK is valid corn, will be the service portion of corn
     * @example `claims` for PK of `RESOURCE#corn:claims:claim:abc123`
     */
    service: z.string().optional(),
    /**
     * If PK is valid corn, will be the resource type portion of corn
     * @example `claim` for PK of `RESOURCE#corn:claims:claim:abc123`
     */
    resourceType: z.string().optional(),
});
export const DatabaseTagSchema = TagKeysSchema.and(TagSchema.pick({ key: true, value: true, color: true }));
